import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ComponentService } from '../../services/component.service';
import { NicaAnagraficaComponent } from '../nica-anagrafica/nica-anagrafica.component';

@Component({
  selector: 'app-testi-adr',
  templateUrl: './testi-adr.component.html',
  styleUrls: ['./testi-adr.component.css']
})
export class TestiAdrComponent implements OnInit,AfterViewInit {
  @ViewChild('nicaAnagraficaTestiAdr', { static:false }) nicaAnagraficaTestiAdr: NicaAnagraficaComponent;

  @Input() showTitle: boolean = true;
  @Output() rowSelected = new EventEmitter<any>();
  @Input() cerRif:string='';
  @Input() itemData:any;
  gridFilter: string="";
   



  constructor(public userComponentService: ComponentService,) { }
  ngAfterViewInit(): void {
    //console.log("ecco i datiiiiiiiiiiiii ",this.itemData)
    let jj=JSON.parse(this.itemData[0].filter)
    this.nicaAnagraficaTestiAdr.filter="?$filter=eer eq '"+jj.eer+"'"
    this.nicaAnagraficaTestiAdr.refresh(); 
    this.nicaAnagraficaTestiAdr.costantValues=[{key:'eer',value:jj.eer}]  
     }

  ngOnInit() {
    
  }
  emettiChiusuraCaption(e){
    
    this.userComponentService.destroyCurrentOpenPopUp('TestiAdrComponent')
    

  }
  optionalButton(e){
    console.log("Premuto Selezione ",e)
    if(e.name=='importa'){
      this.nicaAnagraficaTestiAdr.selezionaRiga(e.row.key)
      e.data=e.row.data;
      this.nicaAnagraficaTestiAdr.SelectionChanged(e)
    }
  }
  AllEvent(e: any) {
    if (e.name == "onSelectionChanged") {
      e.isSelected=true;
      this.rowSelected.emit(e);     
      console.log(e);
    }
  }
}
